import { render, staticRenderFns } from "./NotificationKey.vue?vue&type=template&id=76c3fec0&scoped=true&"
import script from "./NotificationKey.vue?vue&type=script&lang=ts&"
export * from "./NotificationKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c3fec0",
  null
  
)

export default component.exports